import React, { useState } from 'react';
import { Box, Text, Input, Button, Select } from '@chakra-ui/react';
import { SignagesType } from '../Table/MaintenanceSignageTable';
import { QuerySignagesApi } from '../../../../apis/QueryMaintenance.api';
import { SignageSearchCondition } from '../../../../pages/SignageMaintenance';

interface props {
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<SignagesType[] | undefined | null>
  >;
  Query: SignageSearchCondition;
  setQuery: React.Dispatch<React.SetStateAction<SignageSearchCondition>>;
  SearchStateSwitch: () => void;
}

const SignageSearchBox: React.FC<props> = (props) => {
  const { setMaintenanceDatas, Query, setQuery, SearchStateSwitch } = props;
  const [course, setCourse] = useState('');
  const [inbound, setInbound] = useState('');
  const SerachGetApi = async () => {
    const params = new URLSearchParams();
    Query.sort.key !== '' &&
      params.append(
        'order',
        Query.sort.key + (Query.sort.sortType ? '_asc' : '_desc')
      );
    course !== '' && params.append('course_contains', course);
    inbound !== '' && params.append('inbound_flg_eq', inbound);

    const apiQuery = '/?' + params.toString();

    setQuery((pre) => ({ ...pre, course: course, inbound: inbound }));
    const response = await QuerySignagesApi(apiQuery);
    if (response.success) {
      setMaintenanceDatas(response.data as SignagesType[]);
      SearchStateSwitch();
    }
  };

  return (
    <>
      <Box
        border='1px'
        borderColor='gray'
        ml={14}
        gridRow='2/3'
        gridColumn='2/2'
        w='80%'
        h='200px'
        bgColor='#f4f4f4'
        fontSize={14}
      >
        <Box bgColor='#e5e6e7'>
          <Text>検索条件</Text>
        </Box>
        <Box w='90%'>
          <Text ml={2} mt={1}>
            コースで絞り込む
          </Text>
          <Input
            h='8'
            ml={2}
            bgColor='white'
            onChange={(e) => setCourse(e.target.value)}
          ></Input>
          <Text ml={2} mt={1}>
            INBOUND FLG
          </Text>
          <Select h='8' ml={2} onChange={(e) => setInbound(e.target.value)}>
            <option value=''>任意</option>
            <option value='true'>Yes</option>
            <option value='false'>No</option>
          </Select>
          <Button
            ml={2}
            mt={2}
            bgColor='gray.800'
            color='white'
            onClick={() => SerachGetApi()}
          >
            絞り込む
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default React.memo(SignageSearchBox);
